module.exports = __webpack_public_path__ + "img/spoken_original_voice.d16abf69.svg";